import React from 'react';
import {formatRoute} from 'react-router-named-routes';
import {ADD_NEW_STORE_PATH} from '@src/paths';
import TopBar from '@src/components/TopBar';
import {useTranslation} from 'react-i18next';
import {useTracking} from '@src/hooks/useTracking';
import trackingEvents from '@src/trackingEvents';

const ListingInformationPage = () => {
  const {t} = useTranslation();
  const trackEvent = useTracking();
  return (
    <>
      <TopBar
        title={t('pages.AddNewStore.listingInformationPage.title')}
        breadcrumb={{
          label: t('pages.AddNewStore.breadcrumb'),
          accessibilityLabel: t('pages.AddNewStore.breadcrumb'),
          href: formatRoute(ADD_NEW_STORE_PATH),
          onClick: () =>
            trackEvent({
              url: window.location.href,
              page: 'AddNewStore',
              event: trackingEvents.AddNewStoreBackToAddNewStoreClicked,
            }),
        }}
      />
      <iframe
        src="https://ezcaterforms.formstack.com/forms/ezcater_onboarding_information"
        title="Formstack Form"
        width="100%"
        height="100%"
      />
    </>
  );
};

export default ListingInformationPage;
